const SAFE_COLOR_PATTERN = /^#[0-9a-fA-F]{3,8}$|^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/;
const SAFE_FONT_PATTERN = /^[a-zA-Z0-9\s,'"-]{1,120}$/;

function safeColor(value, fallback) {
  if (typeof value !== "string") {
    return fallback;
  }
  const trimmed = value.trim();
  return SAFE_COLOR_PATTERN.test(trimmed) ? trimmed : fallback;
}

function safeFont(value, fallback) {
  if (typeof value !== "string") {
    return fallback;
  }
  const trimmed = value.trim();
  return SAFE_FONT_PATTERN.test(trimmed) ? trimmed : fallback;
}

export function buildBrandingCssVariables(manifest) {
  const branding = manifest?.branding || {};
  const colors = branding.colors || {};

  return {
    "--cv-color-primary": safeColor(colors.primary, "#1e3a5f"),
    "--cv-color-secondary": safeColor(colors.secondary, colors.accent || "#2563eb"),
    "--cv-color-accent": safeColor(colors.accent, "#2563eb"),
    "--cv-color-background": safeColor(colors.background, "#f8f9fb"),
    "--cv-color-text": safeColor(colors.text, "#1a1a1a"),
    "--cv-font-heading": safeFont(branding.fonts?.heading, "Georgia, serif"),
    "--cv-font-body": safeFont(branding.fonts?.body, "system-ui, sans-serif"),
  };
}

export function getViewDisplayName(manifest) {
  return manifest?.branding?.name || manifest?.name || "Client View";
}
